module.exports = require("@makemydeal/dr-activities-common");